import { ICareMap } from '../caremap/ICareMap';
import { InnerhivePage } from '../InnerhivePage';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { ActiveCareMapProviderV2 } from '../ActiveCareMapProvider';
import { ActivePatientView } from '../household/ActivePatientView';
import { EditPatientDrawer } from '../household/patient/EditPatientDrawer';
import { QuickAddButtons } from './QuickAddButtons';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { useEffect } from 'react';
import { CareTabsProvider } from './CareTabsProvider';

export const CarePage: React.FC<{ caremapId: string; }> = ({ caremapId }) => {
    const caremapState = useInstance(CareMapState);
    useSubscription(() => caremapState);

    return (
        <ActiveCareMapProviderV2 careMapId={caremapId}>
            <CarePageWithCaremap />
        </ActiveCareMapProviderV2>
    );
};

export const CarePageWithCaremap: React.FC = () => {
    const caremapState = useInstance(CareMapState);
    const editPatientDrawer = useInstance(EditPatientDrawer);
    const mixpanel = useInstance(MixPanelEventEmitter);
    const tabsProvider = useInstance(CareTabsProvider);

    const caremap = caremapState.getActiveCaremap() as ICareMap;

    useEffect(() => {
        mixpanel.track('Care Profile Tab Opened');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!caremap){
        return null;
    }

    const openEditPatientDrawer = () => {
        editPatientDrawer.open();
    };

    return (
        <InnerhivePage title="Care" tabs={tabsProvider.getTabs()}>
            <ActivePatientView hideNotes hideAppointments onEdit={openEditPatientDrawer} allowDelete />
            <QuickAddButtons trackingFrom="Care Profile" />
        </InnerhivePage>
    );
};
